import _isString from "lodash-es/isString";
import _isArray from "lodash-es/isArray";
import React from "react";
import Translate from "react-translate-component";
import cnames from "classnames";
import Icon from "../Icon/Icon";
import MenuItemType from "./MenuItemType";

class DropdownMenuItem extends React.Component {
  render() {
    const {
      target,
      currentPath,
      includePattern,
      excludePattern,
      additionalClassName,
      icon,
      text,
      behavior,
      submenu,
      // {target, text, disabled} || [{target, text, hidden}]
      hidden,
      disabled
    } = this.props;
    let actualIcon = icon;

    if (_isString(icon)) {
      actualIcon = {
        name: icon
      };
    } // Default icon title if not set


    if (actualIcon && !actualIcon.title) {
      actualIcon.title = "icons." + actualIcon.name;
    } // Default icon size if not set


    if (actualIcon && !actualIcon.size) {
      actualIcon.size = "2x";
    } // Convert sigle strings to array


    let includePatternArray = includePattern;

    if (_isString(includePattern)) {
      includePatternArray = [includePattern];
    }

    let excludePatternArray = excludePattern;

    if (_isString(excludePattern)) {
      excludePatternArray = [excludePattern];
    } // Check patterns which decides should the class names be assigned or not


    let patternMatched = false;

    if (includePattern || excludePattern) {
      patternMatched = true;

      if (includePatternArray) {
        for (let i = 0; i < includePatternArray.length; i++) {
          if (currentPath.indexOf(includePatternArray[i]) === -1) {
            patternMatched = false;
            break;
          }
        }
      }

      if (excludePatternArray) {
        for (let i = 0; i < excludePatternArray.length; i++) {
          if (currentPath.indexOf(excludePatternArray[i]) !== -1) {
            patternMatched = false;
            break;
          }
        }
      }
    } // Choose a behavior, defaults to Always


    let actualBehavior = MenuItemType.Always;

    if (behavior) {
      actualBehavior = behavior;
    } // Show or hide element by it's behavior


    let actuallyHidden = true;

    if (actualBehavior == MenuItemType.Always || actualBehavior == MenuItemType.Dynamic && patternMatched) {
      actuallyHidden = false;
    } //But also count a direct hidding


    if (hidden) {
      actuallyHidden = true;
    } // Click handler for disabled elements


    const emptyClickHandler = event => {
      event.stopPropagation();
    }; // If submenu is a single object, render it as pure link


    let renderAlternativeSubmenu = submenu && !_isArray(submenu);
    return actuallyHidden ? null : /*#__PURE__*/React.createElement("li", {
      className: cnames({
        active: patternMatched,
        disabled: disabled,
        "has-submenu": _isArray(submenu)
      }, additionalClassName),
      onClick: disabled ? emptyClickHandler : target
    }, actualIcon && /*#__PURE__*/React.createElement("div", {
      className: "table-cell"
    }, /*#__PURE__*/React.createElement(Icon, {
      size: actualIcon.size,
      name: actualIcon.name,
      title: actualIcon.title
    })), /*#__PURE__*/React.createElement("div", {
      className: "table-cell"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: text
    }), renderAlternativeSubmenu ? " " : null, renderAlternativeSubmenu ? /*#__PURE__*/React.createElement("span", {
      onClick: submenu.disabled ? emptyClickHandler : event => {
        event.stopPropagation();
        submenu.target(event);
      },
      className: cnames("header-dropdown-sub-link", {
        enabled: !submenu.disabled
      })
    }, /*#__PURE__*/React.createElement(Translate, {
      content: submenu.text
    })) : null));
  }

}

export default DropdownMenuItem;